<template>
  <div>
    <section class="member-box">
      <div class="container">
        <div class="box">
          <h1>{{ $t("會員登入") }}</h1>
          <hr />
          <div class="form-group phone-box">
            <label for="formGroupExampleInput">{{ $t("手機") }}</label>
            <div class="phone">
              <vue-tel-input
                @input="onInput"
                autocomplete="new-phone"
              ></vue-tel-input>
            </div>
          </div>
          <div class="form-group" style="position: relative">
            <label for="formGroupExampleInput">{{ $t("密碼") }}</label>
            <input
              :placeholder="$t('請輸入您的密碼')"
              :type="viewpassword ? 'text' : 'password'"
              class="form-control"
              v-model="password"
              autocomplete="new-password"
            />
            <span id="showPw" @click="viewpassword = !viewpassword"
              ><img
                :src="viewpassword ? 'img/eyes-n.png' : 'img/eyes-y.png'"
                style="width: auto; height: 16px"
            /></span>
          </div>
          <div class="form-group" style="margin-left: 90px" v-if="false">
            <div class="check-box">
              <input
                id="remember"
                type="checkbox"
                aria-label="Checkbox for following text input"
                v-model="remember"
              />
              <label for="remember">{{ $t("記住我(30天)") }}</label>
            </div>
          </div>
          <div
            class="form-group"
            style="position: relative"
            v-show="needVerify"
          >
            <label for="formGroupExampleInput">{{ $t("驗證碼") }}</label>
            <input
              :placeholder="$t('請輸入驗證碼')"
              type="text"
              class="form-control"
              v-model="verifyCodeCheck"
              autocomplete="new-password"
            />
          </div>
          <div
            class="form-group"
            style="
              justify-content: flex-end;
              margin-top: -15px;
              margin-bottom: 15px;
            "
            v-show="needVerify"
          >
            <canvas
              id="verifyCodeCanvas"
              width="140"
              height="40"
              style="cursor: pointer"
              @click="reVerifyCode()"
            ></canvas>
          </div>
          <div class="btn-box">
            <button @click="handleLogin">{{ $t("登入") }}</button>
            <router-link
              :to="{ name: 'Register' }"
              tag="button"
              class="phone"
              >{{ $t("手機號碼註冊") }}</router-link
            >
            <router-link :to="{ name: 'OldLogin' }" tag="button" class="old"
              >{{ $t("舊會員登入")
              }}<P>{{ $t("僅限卡片會員") }}</P></router-link
            >
            <div class="circle-btn">
              <p>{{ $t("其他登入方式：") }}</p>
              <button @click="facebookLogin_App" v-if="isMobile" class="fb">
                <img src="img/fb_icon.svg" alt="" />
              </button>
              <button @click="lineLogin_App" v-if="isMobile" class="line">
                <img src="img/line_icon.svg" alt="" />
              </button>
              <button @click="googleLogin_App" v-if="isMobile" class="google">
                <img src="img/google_icon.svg" alt="" />
              </button>
              <button @click="facebookLogin" v-if="!isMobile" class="fb">
                <img src="img/fb_icon.svg" alt="" />
              </button>
              <button @click="lineLogin" v-if="!isMobile" class="line">
                <img src="img/line_icon.svg" alt="" />
              </button>
              <div v-if="!isMobile" style="margin: 0 10px">
                <GoogleLoginButton />
              </div>
            </div>
          </div>
          <!-- 0518 增加 連結 -->
          <router-link class="note" :to="{ name: 'Forget' }">{{
            $t("忘記密碼？")
          }}</router-link>
          <router-link
            class="note other-btn"
            :to="{
              name: 'OtherList',
            }"
            >{{ $t("其他資訊") }}<span>》</span></router-link
          >
          <div style="display: flex; text-align: end">
            <div style="width: 100%">Ver.{{ GLOBAL.localVer }}</div>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import GoogleLoginButton from "@/components/GoogleLoginButton.vue";

import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import AES from "@/utils/aes.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueI18n from "vue-i18n";
import { v4 as uuidv4 } from "uuid";
import Storage from "@/utils/storage.js";

Vue.use(VueTelInput, {
  autoDefaultCountry: true,
  defaultCountry: 886,
  dropdownOptions: {
    showDialCodeInSelection: true,
  },
  inputOptions: {
    placeholder: "",
  },
});
Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
    zh_tw: {
    "會員登入": "會員登入",
    "手機": "手機",
    "密碼": "密碼",
    "請輸入您的密碼": "請輸入您的密碼",
    "記住我(30天)": "記住我(30天)",
    "登入": "登入",
    "手機號碼註冊": "手機號碼註冊",
    "舊會員登入": "舊會員登入",
    "僅限卡片會員": "僅限卡片會員",
    "忘記密碼？": "忘記密碼？",
    "其他資訊": "其他資訊",
    "錯誤": "錯誤",
    "手機號碼格式錯誤": "手機號碼格式錯誤",
    "確定": "確定",
    "登入成功": "登入成功",
    "手機號碼或密碼不可為空": "手機號碼或密碼不可為空",
    "其他登入方式：": "其他登入方式：",
  },
  en: {
    "會員登入": "Log in",
    "手機": "Mobile number",
    "密碼": "Password",
    "請輸入您的密碼": "Please enter your password",
    "記住我(30天)": "Remember me (30 days)",
    "登入": "Log in",
    "手機號碼註冊": "Phone Register",
    "舊會員登入": "Old member log in",
    "僅限卡片會員": "Card member only",
    "忘記密碼？": "Forgot the password?",
    "其他資訊": "Other info",
    "錯誤": "Error",
    "手機號碼格式錯誤": "Wrong mobile number format",
    "確定": "Confirm",
    "登入成功": "Logged in",
    "手機號碼或密碼不可為空": "The mobile number or password cannot be empty",
    "其他登入方式：": "Other Login Methods：",
  },
  jp: {
    "會員登入": "会員ログイン",
    "手機": "携帯電話",
    "密碼": "パスワード",
    "請輸入您的密碼": "パスワードを入力してください",
    "記住我(30天)": "覚えておいてください(30日)",
    "登入": "ログイン",
    "手機號碼註冊": "電話番号登録",
    "舊會員登入": "旧会員ログイン",
    "僅限卡片會員": "カード会員限定",
    "忘記密碼？": "パスワードをお忘れの方",
    "其他資訊": "その他の情報",
    "錯誤": "エラー",
    "手機號碼格式錯誤": "電話番号の形式が正しくありません",
    "確定": "確定",
    "登入成功": "ログインに成功しました",
    "手機號碼或密碼不可為空": "電話番号又はパスワードは必ず入力してください",
    "其他登入方式：": "その他のログイン方法：",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "Login",
  components: {
    GoogleLoginButton,
  },
  i18n,
  data() {
    return {
      countryCallingCode: "",
      number: "",
      valid: false,
      password: "",
      remember: false,
      viewpassword: false,
      isMobile:
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null && typeof cordova != "undefined",
      appVersion: "",
      appVer: 0,
      needVerify: false,
      verifyCode: "",
      verifyCodeCheck: "",
    };
  },
  created: function () {
    window.fbAsyncInit = function () {
      FB.init({
        appId: "145533181767491",
        xfbml: true,
        version: "v16.0",
      });
      FB.AppEvents.logPageView();
    };

    if (!window.FB) {
      (function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    }

    if (window.chcp) {
      let that = this;
      window.chcp.getVersionInfo((error, data) => {
        that.appVersion = data.appVersion;
        var ver = parseInt(data.appVersion.replaceAll(".", ""));
        that.appVer = ver;
        console.log(that.appVersion + ", " + that.appVer);
      });
    }
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套Class
    $(".wrapper").addClass("member-singin");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }

    if (Storage.isKey("ek_login_fail_times")) {
      this.needVerify = true;
      this.reVerifyCode();
    }

    // if (!this.isMobile) {
    //   window.google.accounts.id.initialize({
    //     client_id:
    //       "240420624722-7vn119ldtedd2b30dsll3ekaguouemm4.apps.googleusercontent.com",
    //     callback: this.googleLogin,
    //   });
    //   window.google.accounts.id.prompt();
    // }
  },
  updated: function () {},
  methods: {
    reVerifyCode: function () {
      this.verifyCode = "";
      for (var i = 0; i < 4; i++) {
        this.verifyCode += String(Math.floor(Math.random() * (9 - 0 + 1)) + 0);
      }
      this.verifyCodeCheck = "";
      // 繪圖
      var canvas = document.getElementById("verifyCodeCanvas");
      var ctx = canvas.getContext("2d");
      ctx.textBaseline = "bottom";
      // 背景
      ctx.fillStyle = this.randomColor(180, 240);
      ctx.fillRect(0, 0, 140, 40);
      // 文字
      for (let i = 0; i < this.verifyCode.length; i++) {
        this.drawText(ctx, this.verifyCode[i], i);
      }
      this.drawLine(ctx);
      this.drawDot(ctx);
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    randomColor(min, max) {
      var r = this.randomNum(min, max);
      var g = this.randomNum(min, max);
      var b = this.randomNum(min, max);
      return "rgb(" + r + "," + g + "," + b + ")";
    },
    drawText(ctx, txt, i) {
      ctx.fillStyle = this.randomColor(50, 160);
      ctx.font = "42px SimHei";
      var x = (i + 1) * (140 / (this.verifyCode.length + 1)) - 6;
      var y = this.randomNum(43, 46);
      var deg = this.randomNum(-30, 30);
      ctx.translate(x, y);
      ctx.rotate((deg * Math.PI) / 270);
      ctx.fillText(txt, 0, 0);
      ctx.rotate((-deg * Math.PI) / 270);
      ctx.translate(-x, -y);
    },
    drawLine(ctx) {
      for (let i = 0; i < 2; i++) {
        ctx.strokeStyle = this.randomColor(40, 180);
        ctx.beginPath();
        ctx.moveTo(this.randomNum(0, 140), this.randomNum(0, 40));
        ctx.lineTo(this.randomNum(0, 140), this.randomNum(0, 40));
        ctx.stroke();
      }
    },
    drawDot(ctx) {
      for (let i = 0; i < 20; i++) {
        ctx.fillStyle = this.randomColor(0, 255);
        ctx.beginPath();
        ctx.arc(
          this.randomNum(0, 140),
          this.randomNum(0, 40),
          1,
          0,
          2 * Math.PI
        );
        ctx.fill();
      }
    },
    needUpdate: function () {
      Vue.swal({
        heightAuto: false,
        title: "需要更新APP",
        text:
          "您安裝的APP版本(" +
          this.appVersion +
          ")未支援此功能, 若要使用第三方登入, 請至APP商店下載最新版本, 造成不便敬請見諒!",
        icon: "info",
        allowOutsideClick: false,
        confirmButtonText: "立即前往",
        showCancelButton: true,
        cancelButtonText: "暫不更新",
      }).then((result) => {
        if (result.isConfirmed) {
          cordova.getAppVersion.getPackageName(function (pkgname) {
            if (device.platform == "iOS") {
              cordova.InAppBrowser.open(
                "itms-apps://itunes.apple.com/app/id1415685647",
                "_system"
              );
            } else {
              cordova.InAppBrowser.open(
                "market://details?id=" + pkgname,
                "_system"
              );
            }
          });
        }
      });
    },
    onInput(phone, phoneObject, input) {
      this.countryCallingCode = phoneObject.countryCallingCode;
      this.number = phoneObject.number;
      this.valid = phoneObject.valid;
    },
    handleLogin() {
      let that = this;
      // 顯示請稍候
      this.$swal({
        heightAuto: false,
        title: that.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: function () {
          that.$swal.showLoading();
        },
      });
      if (!this.valid) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("手機號碼格式錯誤"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
      } else {
        let countryCallingCode =
          this.countryCallingCode == null ? "" : this.countryCallingCode;
        let number = this.number == null ? "" : this.number;
        let password = this.password;
        if (this.needVerify && this.verifyCodeCheck != this.verifyCode) {
          this.$swal({
            heightAuto: false,
            title: this.$t("錯誤"),
            text: this.$t("請輸入正確的驗證碼"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: this.$t("確定"),
          });
          this.reVerifyCode();
          return;
        }
        // 帳號密碼需驗證不能為空
        if (countryCallingCode !== "" && number !== "" && password !== "") {
          let token = "";
          if (this.needVerify) {
            token = AES.encrypt(
              countryCallingCode +
                "|" +
                number +
                "|" +
                password +
                "|" +
                this.verifyCode +
                "|" +
                this.verifyCodeCheck
            );
          } else {
            token = AES.encrypt(
              countryCallingCode + "|" + number + "|" + password
            );
          }
          $.ajax({
            url:
              that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/Login",
            type: "post",
            data: {
              token: token
            },
            dataType: "json",
            error: function (jqXHR, textStatus, errorThrown) {
              var msg = "";
              if (jqXHR.status === 0) {
                msg = "0";
              } else if (jqXHR.status == 404) {
                msg = "404";
              } else if (jqXHR.status == 500) {
                msg = "500";
              } else if (textStatus === "parsererror") {
                msg = "-1001";
              } else if (textStatus === "timeout") {
                msg = "-1002";
              } else if (textStatus === "abort") {
                msg = "-1003";
              } else {
                msg = jqXHR.responseText;
              }
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: "連線過程發生錯誤(" + msg + "), 請稍後再試一次",
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            },
            success: function (res) {
              // 判斷結果
              if (res.ok) {
                // 儲存登入Token
                // if (that.remember) {
                //   that.$cookies.set("ek_login_token", res.LoginToken, "30d");
                // } else {
                //   that.$cookies.set("ek_login_token", res.LoginToken, "1d");
                // }
                //that.$cookies.set("ek_login_token", res.LoginToken, "1y");
                Storage.remove("ek_login_fail_times");
                Storage.set("ek_login_token", res.LoginToken);
                that.$swal({
                  heightAuto: false,
                  icon: "success",
                  title: that.$t("登入成功"),
                  showConfirmButton: false,
                  timer: 1500,
                  willClose: function () {
                    // 轉到首頁
                    that.$router.push("/");
                  },
                  allowOutsideClick: false,
                });
              } else if (res.error_msg) {
                var error_msg = JSON.parse(res.error_msg);
                var tryTimes = 1;
                if (Storage.isKey("ek_login_fail_times")) {
                  tryTimes = parseInt(Storage.get("ek_login_fail_times"));
                  tryTimes += 1;
                }
                Storage.set("ek_login_fail_times", tryTimes);
                that.needVerify = true;
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: error_msg[i18n.locale],
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
                that.reVerifyCode();
              }
            },
          });
        } else {
          this.$swal({
            heightAuto: false,
            title: this.$t("錯誤"),
            text: this.$t("手機號碼或密碼不可為空"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: this.$t("確定"),
          });
        }
      }
    },
    googleLogin_App() {
      if (this.appVer < 2018) {
        this.needUpdate();
        return;
      }
      let that = this;
      // 顯示請稍候
      this.$swal({
        heightAuto: false,
        title: that.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: function () {
          that.$swal.showLoading();
        },
      });
      window.plugins.googleplus.login(
        {
          offline: true,
        },
        function (res) {
          // 登入成功
          // 已登入過
          let token = AES.encrypt("Google|" + res.userId);
          $.ajax({
            url:
              that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/Login",
            type: "post",
            data: {
              token: token,
              OAuthInfo: JSON.stringify(res),
            },
            dataType: "json",
            error: function (jqXHR, textStatus, errorThrown) {
              var msg = "";
              if (jqXHR.status === 0) {
                msg = "0";
              } else if (jqXHR.status == 404) {
                msg = "404";
              } else if (jqXHR.status == 500) {
                msg = "500";
              } else if (textStatus === "parsererror") {
                msg = "-1001";
              } else if (textStatus === "timeout") {
                msg = "-1002";
              } else if (textStatus === "abort") {
                msg = "-1003";
              } else {
                msg = jqXHR.responseText;
              }
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: "連線過程發生錯誤(" + msg + "), 請稍後再試一次",
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            },
            success: function (res_login) {
              // 判斷結果
              if (res_login.ok) {
                Storage.set("ek_login_token", res_login.LoginToken, "1y");
                that.$swal({
                  heightAuto: false,
                  icon: "success",
                  title: that.$t("登入成功"),
                  showConfirmButton: false,
                  timer: 1500,
                  willClose: function () {
                    // 轉到首頁
                    that.$router.push("/");
                  },
                  allowOutsideClick: false,
                });
              } else if (res_login.error_msg) {
                var error_msg = JSON.parse(res_login.error_msg);
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text:
                    error_msg[i18n.locale],
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              }
            },
          });
        },
        function (err) {
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: "登入過程發生錯誤, 請稍後再試一次\n" + JSON.stringify(err),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        }
      );
    },
    facebookLogin_App() {
      if (this.appVer < 2018) {
        this.needUpdate();
        return;
      }
      let that = this;
      // 顯示請稍候
      this.$swal({
        heightAuto: false,
        title: that.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: function () {
          that.$swal.showLoading();
        },
      });
      facebookConnectPlugin.login(
        ["public_profile"],
        function (userData) {
          // 登入成功
          let token = AES.encrypt("Facebook|" + userData.authResponse.userID);
          $.ajax({
            url:
              that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/Login",
            type: "post",
            data: {
              token: token,
              OAuthInfo: JSON.stringify(userData),
            },
            dataType: "json",
            error: function (jqXHR, textStatus, errorThrown) {
              var msg = "";
              if (jqXHR.status === 0) {
                msg = "0";
              } else if (jqXHR.status == 404) {
                msg = "404";
              } else if (jqXHR.status == 500) {
                msg = "500";
              } else if (textStatus === "parsererror") {
                msg = "-1001";
              } else if (textStatus === "timeout") {
                msg = "-1002";
              } else if (textStatus === "abort") {
                msg = "-1003";
              } else {
                msg = jqXHR.responseText;
              }
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: "連線過程發生錯誤(" + msg + "), 請稍後再試一次",
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            },
            success: function (res_login) {
              // 判斷結果
              if (res_login.ok) {
                Storage.set("ek_login_token", res_login.LoginToken, "1y");
                that.$swal({
                  heightAuto: false,
                  icon: "success",
                  title: that.$t("登入成功"),
                  showConfirmButton: false,
                  timer: 1500,
                  willClose: function () {
                    // 轉到首頁
                    that.$router.push("/");
                  },
                  allowOutsideClick: false,
                });
              } else if (res_login.error_msg) {
                var error_msg = JSON.parse(res_login.error_msg);
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text:
                    error_msg[i18n.locale],
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              }
            },
          });
        },
        function loginError(error) {
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: "登入過程發生錯誤, 請稍後再試一次",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        }
      );
    },
    lineLogin_App() {
      if (this.appVer < 2018) {
        this.needUpdate();
        return;
      }
      let that = this;
      // 顯示請稍候
      this.$swal({
        heightAuto: false,
        title: that.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: function () {
          that.$swal.showLoading();
        },
      });
      lineLogin.login(
        function (result) {
          // 登入成功
          let token = AES.encrypt("LINE|" + result.userID);
          $.ajax({
            url:
              that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/Login",
            type: "post",
            data: {
              token: token,
              OAuthInfo: JSON.stringify(result),
            },
            dataType: "json",
            error: function (jqXHR, textStatus, errorThrown) {
              var msg = "";
              if (jqXHR.status === 0) {
                msg = "0";
              } else if (jqXHR.status == 404) {
                msg = "404";
              } else if (jqXHR.status == 500) {
                msg = "500";
              } else if (textStatus === "parsererror") {
                msg = "-1001";
              } else if (textStatus === "timeout") {
                msg = "-1002";
              } else if (textStatus === "abort") {
                msg = "-1003";
              } else {
                msg = jqXHR.responseText;
              }
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: "連線過程發生錯誤(" + msg + "), 請稍後再試一次",
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            },
            success: function (res) {
              // 判斷結果
              if (res.ok) {
                Storage.set("ek_login_token", res.LoginToken, "1y");
                that.$swal({
                  heightAuto: false,
                  icon: "success",
                  title: that.$t("登入成功"),
                  showConfirmButton: false,
                  timer: 1500,
                  willClose: function () {
                    // 轉到首頁
                    that.$router.push("/");
                  },
                  allowOutsideClick: false,
                });
              } else if (res.error_msg) {
                var error_msg = JSON.parse(res.error_msg);
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: error_msg[i18n.locale],
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              }
            },
          });
        },
        function (error) {
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: "登入過程發生錯誤, 請稍後再試一次",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        }
      );
    },
    googleLogin(response) {
      let that = this;
      // 顯示請稍候
      this.$swal({
        heightAuto: false,
        title: that.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: function () {
          that.$swal.showLoading();
        },
      });
      $.ajax({
        url:
          that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/LoginGoogle",
        type: "post",
        data: {
          credential: response.credential,
        },
        dataType: "json",
        error: function (jqXHR, textStatus, errorThrown) {
          var msg = "";
          if (jqXHR.status === 0) {
            msg = "0";
          } else if (jqXHR.status == 404) {
            msg = "404";
          } else if (jqXHR.status == 500) {
            msg = "500";
          } else if (textStatus === "parsererror") {
            msg = "-1001";
          } else if (textStatus === "timeout") {
            msg = "-1002";
          } else if (textStatus === "abort") {
            msg = "-1003";
          } else {
            msg = jqXHR.responseText;
          }
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: "連線過程發生錯誤(" + msg + "), 請稍後再試一次",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            // 儲存登入Token
            // if (that.remember) {
            //   that.$cookies.set("ek_login_token", res.LoginToken, "30d");
            // } else {
            //   that.$cookies.set("ek_login_token", res.LoginToken, "1d");
            // }
            Storage.set("ek_login_token", res.LoginToken, "1y");
            that.$swal({
              heightAuto: false,
              icon: "success",
              title: that.$t("登入成功"),
              showConfirmButton: false,
              timer: 1500,
              willClose: function () {
                // 轉到首頁
                that.$router.push("/");
              },
              allowOutsideClick: false,
            });
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        },
        // error: function () {},
        // success: function (res) {
        //   // 判斷結果
        //   if (res.ok) {
        //     that.$swal({
        //       title: that.$t("測試訊息"),
        //       text: res.data,
        //       allowOutsideClick: false,
        //       confirmButtonText: that.$t("確定"),
        //     });
        //   } else if (res.error) {
        //     that.$swal({
        //       title: that.$t("錯誤"),
        //       text: i18n.locale == "en" ? res.error_en : res.error,
        //       icon: "error",
        //       allowOutsideClick: false,
        //       confirmButtonText: that.$t("確定"),
        //     });
        //   }
        // },
      });
    },
    facebookLogin() {
      let that = this;
      // 顯示請稍候
      this.$swal({
        heightAuto: false,
        title: that.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: function () {
          that.$swal.showLoading();
        },
      });
      FB.login(
        function (response) {
          if (response.status === "connected") {
            $.ajax({
              url:
                that.GLOBAL.apiSrc +
                that.GLOBAL.subDirectory +
                "/Htmlv2/LoginFB",
              type: "post",
              data: {
                oAuthId: response.authResponse.userID,
                OAuthInfo: JSON.stringify(response),
              },
              dataType: "json",
              error: function (jqXHR, textStatus, errorThrown) {
                var msg = "";
                if (jqXHR.status === 0) {
                  msg = "0";
                } else if (jqXHR.status == 404) {
                  msg = "404";
                } else if (jqXHR.status == 500) {
                  msg = "500";
                } else if (textStatus === "parsererror") {
                  msg = "-1001";
                } else if (textStatus === "timeout") {
                  msg = "-1002";
                } else if (textStatus === "abort") {
                  msg = "-1003";
                } else {
                  msg = jqXHR.responseText;
                }
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: "連線過程發生錯誤(" + msg + "), 請稍後再試一次",
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              },
              success: function (res) {
                // 判斷結果
                if (res.ok) {
                  Storage.set("ek_login_token", res.LoginToken, "1y");
                  that.$swal({
                    heightAuto: false,
                    icon: "success",
                    title: that.$t("登入成功"),
                    showConfirmButton: false,
                    timer: 1500,
                    willClose: function () {
                      // 轉到首頁
                      that.$router.push("/");
                    },
                    allowOutsideClick: false,
                  });
                } else if (res.error_msg) {
                  var error_msg = JSON.parse(res.error_msg);
                  that.$swal({
                    heightAuto: false,
                    title: that.$t("錯誤"),
                    text: error_msg[i18n.locale],
                    icon: "error",
                    allowOutsideClick: false,
                    confirmButtonText: that.$t("確定"),
                  });
                }
              },
            });
          } else {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: "登入過程發生錯誤, 請稍後再試一次",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        },
        // 授權 - 個人資料&Email
        { scope: "public_profile,email" }
      );
      // 檢查登入狀態
      // FB.getLoginStatus(function (response) {
      //   // 登入狀態 - 已登入
      //   if (response.status === "connected") {
      //     that.$swal({
      //       title: that.$t("測試訊息"),
      //       text: JSON.stringify(response),
      //       allowOutsideClick: false,
      //       confirmButtonText: that.$t("確定"),
      //     });
      //   } else {
      //     // 登入狀態 - 未登入
      //     // 用戶登入(確認授權)
      //     FB.login(
      //       function (res) {
      //         that.$swal({
      //           title: that.$t("測試訊息"),
      //           text: JSON.stringify(res),
      //           allowOutsideClick: false,
      //           confirmButtonText: that.$t("確定"),
      //         });
      //       },
      //       // 授權 - 個人資料&Email
      //       { scope: "public_profile,email" }
      //     );
      //   }
      // });
    },
    lineLogin() {
      let URL = "https://access.line.me/oauth2/v2.1/authorize?";
      URL += "response_type=code";
      URL += "&client_id=1660744776";
      URL +=
        "&redirect_uri=" +
        encodeURI(
          this.GLOBAL.apiSrc + this.GLOBAL.subDirectory + "/Htmlv2/LoginLine"
        );
      URL += "&state=" + uuidv4();
      URL += "&scope=profile";
      window.location.href = URL;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.member-box .form-group .phone {
  border: none;
}
.vue-tel-input {
  width: 100%;
}
#showPw {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue